/**
 * AI Assist Strategies Page (Web)
 * Placeholder for AI assist strategies
 */

import { Container, Typography, Box } from '@mui/material';
import { AuthenticatedLayout } from '../../components/layout/AuthenticatedLayout';

export function AIAssistStrategiesPage() {
  return (
    <AuthenticatedLayout>
      <Container maxWidth="lg">
        <Box sx={{ mt: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            AI Assist Strategies
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Strategies feature coming soon...
          </Typography>
        </Box>
      </Container>
    </AuthenticatedLayout>
  );
}

